import { Outlet } from 'react-router';

import { HeaderToolbarAndContentLayout } from 'src/common/primitives/HeaderToolbarAndContentLayout';

import { BillingNav } from './BillingNav';

export function BillingLayout() {
  return (
    <HeaderToolbarAndContentLayout
      preContent={<BillingNav />}
      actionSection={<div />}
      content={<Outlet />}
    />
  );
}
